import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M18.5327 11.2844H12.8287V5.58042C12.8287 5.15828 12.4787 4.80822 12.0565 4.80822C11.6344 4.80822 11.2843 5.15828 11.2843 5.58042V11.2844H5.58036C5.15822 11.2844 4.80816 11.6345 4.80816 12.0566C4.80816 12.4787 5.15822 12.8288 5.58036 12.8288H11.2843V18.5328C11.2843 18.9549 11.6344 19.305 12.0565 19.305C12.4787 19.305 12.8287 18.9549 12.8287 18.5328V12.8288H18.5327C18.9549 12.8288 19.3049 12.4787 19.3049 12.0566C19.3049 11.6345 18.9652 11.2844 18.5327 11.2844Z"
}), React.createElement("path", {
  d: "M11.9949 0C5.38481 0 0 5.38481 0 11.9949C0 18.6049 5.38481 23.9897 11.9949 23.9897C18.6049 23.9897 23.9897 18.6049 23.9897 11.9949C23.9897 5.38481 18.6152 0 11.9949 0ZM11.9949 22.4556C6.22909 22.4556 1.5444 17.7606 1.5444 12.0051C1.5444 6.24968 6.23938 1.5444 11.9949 1.5444C17.7606 1.5444 22.4453 6.23938 22.4453 11.9949C22.4453 17.7503 17.7606 22.4556 11.9949 22.4556Z"
})), React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: "23.31",
  height: "23.31",
  fill: "white",
  transform: "scale(1.0296)"
})))), "IconInclude");